export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const login = (state = {}, action = {}) => {
    switch (action.type) {
        case LOGIN_SUCCESS: {
            return {
                authenticated: true
            }
        }
        case LOGIN_FAILURE: {
            console.log('login failure!!!', action);
            return {
                authenticated: false,
                error: action.message
            }
        }
        default:
            return state
    }

};


// WEBPACK FOOTER //
// ./src/reducers/login.js